import { spacing } from "./spacing"

/**
 * @deprecated
 */
export const oldGrid = {
  small: {
    /** Number of columns */
    columns: 4,
    /** Spacing inbetween the columns */
    gutter: spacing.small,
    /** Spacing on either side of all columns */
    margin: spacing.small,
  },
  medium: {
    /** Number of columns */
    columns: 8,
    /** Spacing inbetween the columns */
    gutter: spacing.small,
    /** Spacing on either side of all columns */
    margin: spacing.small,
  },
  large: {
    /** Number of columns */
    columns: 12,
    /** Spacing inbetween the columns */
    gutter: spacing.small,
    /** Spacing on either side of all columns */
    margin: spacing.xxLarge,
    /** Maximum width of whole grid, including the margins */
    maxWidth: 1340,
  },
} as const

/**
 * @deprecated
 *
 * Standardised breakpoints mainly used for old grids.
 * Should be used in min-width media queries.
 */
export const oldBreakpoints = {
  /** Should only be used together with grid */
  small: "0px",
  medium: "620px",
  large: "800px",
  xLarge: "1280px",
} as const
